// extracted by mini-css-extract-plugin
module.exports = {"container":"_17wYGXcJlBQfR3XxQVJx4V","link":"_1rRHZmo_edVe5SZAl1THJI","title":"_36ccAtqwApbgxfRAVj-C5T"};